/**
 * Lightweight, data-free country helpers for the public marketing pages'
 * critical path.
 *
 * These are trivial string checks with NO dependency on
 * `react-phone-number-input` (whose country-list, calling-code and locale data
 * add ~200 KB to any chunk that imports it). Keeping them here — separate from
 * `CountryService`, which needs that metadata — is what keeps the phone-number
 * bundle off the homepage's first load. Import from here for a US/region check
 * or a country-derived date format; import `CountryService` only where a full
 * country picker is actually rendered.
 */
const COUNTRY_CODE_US = 'US';

/** True when the country code is the United States (case-insensitive). */
export const isUSCountryCode = (countryCode?: string | null): boolean =>
  countryCode?.toUpperCase() === COUNTRY_CODE_US;

/**
 * date-fns format string for a country: the US uses `MM/dd/yyyy`, everywhere
 * else uses `dd/MM/yyyy`. A pure derivation of the country code — no locale
 * data required.
 */
export const getCountryDateFormat = (countryCode: string): string =>
  isUSCountryCode(countryCode) ? 'MM/dd/yyyy' : 'dd/MM/yyyy';
